import * as moment from "moment-timezone";

export interface GlobalAlert {
  Id: string;
  Title: string;
  ImageUrl: string;
  Link: string;
  ExpirationTimeInMinutes: number;
  Geolocation?: {
    Action: GealocalicationAction,
    Countries: string[],
  };
  Culture: string;
}

export interface ScheduledGlobalAlert {
  id: string;
  dateUtc: moment.Moment;
  content: GlobalAlert | any;
}

export enum GealocalicationAction {
  NoAction = 0,
  Ban = 1,
  Whitelist = 2,
}



// WEBPACK FOOTER //
// ./src/app/editorialtools/models/globalalert.ts